import { Button, Col, Container, Form, Modal, Row, Table } from 'react-bootstrap';
import { Files, Bank, People, FilePerson, House } from 'react-bootstrap-icons';
import { PencilSquare, FileEarmark } from 'react-bootstrap-icons';
import { CustomerFormFieldsProps } from './customer.types';

import { useEffect, useState } from 'react';
import { getFile } from '../../utils/commons.utils';
import FileViewerModal from '../../components/file-viewer-modal';
import api from '../../services/api';

const CustomerFormFields: React.FC<CustomerFormFieldsProps> = ({
  formData,
  handleChange,
  handleFileChange,
  handleBeneficiarySubmit,
  index = null,
  isEdit = false,
  setSelectedBeneficiaryIndex,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [showModalBeneficiary, setShowModalBeneficiary] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState<any | null>(null);
  const [selectedBeneficiary, setSelectedBeneficiary] = useState<any | null>(null);
  const [files, setFiles] = useState<number[]>([]);
  const [isDocumentModalOpen, setIsDocumentModalOpen] = useState(false);
  const [fileBlob, setFileBlob] = useState();
  const [banks, setBanks] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const documentTypes = [
    { id: 1, key: 'identificationDoc', label: 'INE' },
    { id: 2, key: 'addressProof', label: 'Comprobante Domicilio' },
    { id: 3, key: 'taxDoc', label: 'Constancia Fiscal' },
  ];

  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const responseInvestments = await api.get(`/banks`);
        setBanks(responseInvestments.data);
      } catch (error) {
        console.error('Error obteniendo los bancos:', error);
      }
      setIsLoading(false);
    };
    fetchBanks();
  }, []);

  const handleEditClick = (doc: any) => {
    setSelectedDocument(doc);
    setShowModal(true);
  };

  const handleBeneficiaryButton = (e: any) => {
    if (handleBeneficiarySubmit) {
      handleBeneficiarySubmit(e);
    }
    setShowModalBeneficiary(false);
  };

  const handleOpenDocument = async (
    fileUrl: string,
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    e.preventDefault();
    const file = await getFile(fileUrl);
    if (file) {
      setFileBlob(file);
      setIsDocumentModalOpen(true);
    }
  };

  const getDocumentByType = (docTypeId: number) => {
    let documents = formData.documents;
    if (isEdit && selectedBeneficiary) {
      documents = selectedBeneficiary.documents;
    }

    if (index !== null) {
      documents = formData.beneficiaries?.[index]?.documents ?? [];
    }

    if (!documents || documents.length === 0) {
      return null;
    }
    return documents.find((doc) => doc.documentTypeId === docTypeId) || null;
  };

  const renderPersonalData = () => {
    let personalData = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      phone: formData.phone,
      rfc: formData.rfc,
      curp: formData.curp,
      birthDate: formData.birthDate,
      gender: formData.gender,
    };

    if (isEdit && selectedBeneficiary) {
      personalData = {
        firstName: selectedBeneficiary.firstName,
        lastName: selectedBeneficiary.lastName,
        email: selectedBeneficiary.email,
        phone: selectedBeneficiary.phone,
        rfc: selectedBeneficiary.rfc,
        curp: selectedBeneficiary.curp,
        birthDate: selectedBeneficiary.birthDate,
        gender: selectedBeneficiary.gender,
      };
      index = selectedBeneficiary.index;
    }

    if (index !== null) {
      personalData = {
        firstName: formData.beneficiaries?.[index]?.firstName || '',
        lastName: formData.beneficiaries?.[index]?.lastName || '',
        email: formData.beneficiaries?.[index]?.email || '',
        phone: formData.beneficiaries?.[index]?.phone || '',
        rfc: formData.beneficiaries?.[index]?.rfc || '',
        curp: formData.beneficiaries?.[index]?.curp || '',
        birthDate: formData.beneficiaries?.[index]?.birthDate || '',
        gender: formData.beneficiaries?.[index]?.gender || '',
      };
    }

    return (
      <Container>
        <Row className="mb-4 form-title">
          <Col md={6} className="d-flex align-items-center">
            <FilePerson size={18} className="me-2" />
            <h4>Datos Personales</h4>
          </Col>
        </Row>
        <Form.Group as={Row} className="mb-3">
          <Col md={6}>
            <Form.Label className="fw-bold">* Nombre(s)</Form.Label>
            <Form.Control
              type="text"
              name="firstName"
              value={personalData.firstName}
              onChange={(e) => handleChange(e, index)}
              required
            />
          </Col>
          <Col md={6}>
            <Form.Label className="fw-bold">* Apellidos</Form.Label>
            <Form.Control
              type="text"
              name="lastName"
              value={personalData.lastName}
              onChange={(e) => handleChange(e, index)}
              required
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} className="mb-3">
          <Col md={6}>
            <Form.Label className="fw-bold">* Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={personalData.email}
              onChange={(e) => handleChange(e, index)}
              required
            />
          </Col>
          <Col md={6}>
            <Form.Label className="fw-bold">* Teléfono</Form.Label>
            <Form.Control
              type="text"
              name="phone"
              value={personalData.phone}
              onChange={(e) => handleChange(e, index)}
              required
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} className="mb-3">
          <Col md={6}>
            <Form.Label className="fw-bold">* RFC</Form.Label>
            <Form.Control
              type="text"
              name="rfc"
              value={personalData.rfc}
              onChange={(e) => handleChange(e, index)}
              required
            />
          </Col>
          <Col md={6}>
            <Form.Label className="fw-bold">CURP</Form.Label>
            <Form.Control
              type="text"
              name="curp"
              value={personalData.curp}
              onChange={(e) => handleChange(e, index)}
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} className="mb-3">
          <Col md={6}>
            <Form.Label className="fw-bold">Fecha de Nacimiento</Form.Label>
            <Form.Control
              type="date"
              name="birthDate"
              value={personalData.birthDate}
              onChange={(e) => handleChange(e, index)}
            />
          </Col>
          <Col md={6}>
            <Form.Label className="fw-bold">Género</Form.Label>
            <Form.Select
              name="gender"
              value={personalData.gender}
              onChange={(e) => handleChange(e, index)}
            >
              <option value="M">Masculino</option>
              <option value="F">Femenino</option>
            </Form.Select>
          </Col>
        </Form.Group>
      </Container>
    );
  };

  const renderFiscalData = () => {
    let fiscalData = {
      state: formData.state,
      city: formData.city,
      neighborhood: formData.neighborhood,
      address: formData.address,
      addressNumber: formData.addressNumber,
      zipCode: formData.zipCode,
    };

    if (isEdit && selectedBeneficiary) {
      fiscalData = {
        state: selectedBeneficiary.state,
        city: selectedBeneficiary.city,
        neighborhood: selectedBeneficiary.neighborhood,
        address: selectedBeneficiary.address,
        addressNumber: selectedBeneficiary.addressNumber,
        zipCode: selectedBeneficiary.zipCode,
      };
      index = selectedBeneficiary.index;
    }

    if (index !== null) {
      fiscalData = {
        state: formData.beneficiaries?.[index]?.state || '',
        city: formData.beneficiaries?.[index]?.city || '',
        neighborhood: formData.beneficiaries?.[index]?.neighborhood || '',
        address: formData.beneficiaries?.[index]?.address || '',
        addressNumber: formData.beneficiaries?.[index]?.addressNumber || '',
        zipCode: formData.beneficiaries?.[index]?.zipCode || '',
      };
    }

    return (
      <Container>
        <Row className="mb-4 mt-5 form-title">
          <Col md={6} className="d-flex align-items-center">
            <House size={18} className="me-2" />
            <h4>Domicilio Fiscal</h4>
          </Col>
        </Row>
        <Form.Group as={Row} className="mb-3">
          <Col md={4}>
            <Form.Label className="fw-bold">* Estado</Form.Label>
            <Form.Control
              type="text"
              name="state"
              value={fiscalData.state}
              onChange={(e) => handleChange(e, index)}
              required
            />
          </Col>
          <Col md={4}>
            <Form.Label className="fw-bold">* Ciudad</Form.Label>
            <Form.Control
              type="text"
              name="city"
              value={fiscalData.city}
              onChange={(e) => handleChange(e, index)}
              required
            />
          </Col>
          <Col md={4}>
            <Form.Label className="fw-bold">* Colonia</Form.Label>
            <Form.Control
              type="text"
              name="neighborhood"
              value={fiscalData.neighborhood}
              onChange={(e) => handleChange(e, index)}
              required
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} className="mb-3">
          <Col md={4}>
            <Form.Label className="fw-bold">* Dirección</Form.Label>
            <Form.Control
              type="text"
              name="address"
              value={fiscalData.address}
              onChange={(e) => handleChange(e, index)}
              required
            />
          </Col>
          <Col md={4}>
            <Form.Label className="fw-bold">* Número</Form.Label>
            <Form.Control
              type="text"
              name="addressNumber"
              value={fiscalData.addressNumber}
              onChange={(e) => handleChange(e, index)}
              required
            />
          </Col>
          <Col md={4}>
            <Form.Label className="fw-bold">* Código Postal</Form.Label>
            <Form.Control
              type="text"
              name="zipCode"
              value={fiscalData.zipCode}
              onChange={(e) => handleChange(e, index)}
              required
              maxLength={5}
            />
          </Col>
        </Form.Group>
      </Container>
    );
  };

  const renderBankData = () => {
    let bankData = {
      bankId: formData.bankId,
      clabe: formData.clabe,
    };

    if (isEdit && selectedBeneficiary) {
      bankData = {
        bankId: selectedBeneficiary.bankId,
        clabe: selectedBeneficiary.clabe,
      };
      index = selectedBeneficiary.index;
    }

    if (index !== null) {
      bankData = {
        bankId: formData.beneficiaries?.[index]?.bankId || 0,
        clabe: formData.beneficiaries?.[index]?.clabe || '',
      };
    }

    return (
      <Container>
        <Row className="mb-4 mt-5 form-title">
          <Col md={6} className="d-flex align-items-center">
            <Bank size={18} className="me-2" />
            <h4>Datos Bancarios</h4>
          </Col>
        </Row>

        <Form.Group as={Row} className="mb-3">
          <Col md={6}>
            <Form.Label className="fw-bold">* Banco</Form.Label>
            <Form.Select
              name="bankId"
              value={bankData.bankId}
              onChange={(e) => handleChange(e, index)}
            >
              <option value="">Seleccione un banco</option>
              {banks.map((bank) => (
                <option key={bank.id} value={bank.id}>
                  {bank.name}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col md={6}>
            <Form.Label className="fw-bold">* CLABE</Form.Label>
            <Form.Control
              type="text"
              name="clabe"
              value={bankData.clabe}
              onChange={(e) => handleChange(e, index)}
              required
              minLength={18}
              maxLength={18}
            />
          </Col>
        </Form.Group>
      </Container>
    );
  };

  const renderUploadDocuments = () => (
    <Container>
      <Row className="mb-4 mt-5 form-title">
        <Col md={6}>
          <h4>Documentación</h4>
        </Col>
      </Row>

      <Form.Group className="mb-3">
        <Form.Label className="fw-bold">Adjuntar INE</Form.Label>
        <Form.Control
          type="file"
          name="identificationDoc"
          onChange={(e) => handleFileChange(e, 1, index)}
          accept=".pdf,.jpg,.png"
          required
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label className="fw-bold">Adjuntar Comprobante de domicilio</Form.Label>
        <Form.Control
          type="file"
          name="addressProof"
          onChange={(e) => handleFileChange(e, 2, index)}
          accept=".pdf,.jpg,.png"
          required
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label className="fw-bold">Adjuntar Cedula de identificación fiscal</Form.Label>
        <Form.Control
          type="file"
          name="taxDoc"
          onChange={(e) => handleFileChange(e, 3, index)}
          accept=".pdf,.jpg,.png"
          required
        />
      </Form.Group>
    </Container>
  );

  const renderDocuments = () => (
    <Container>
      <Row className="mb-4 mt-5 form-title">
        <Col md={6} className="d-flex align-items-center">
          <Files size={18} className="me-2" />
          <h4>Documentación</h4>
        </Col>
      </Row>
      <Row className="mb-3 mt-5">
        <Table responsive striped bordered hover>
          <thead>
            <tr>
              <th>Tipo de Documento</th>
              <th>Archivo</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {documentTypes.map((doc) => {
              const document = getDocumentByType(doc.id);
              const fileUrl = document
                ? selectedBeneficiary
                  ? `${process.env.REACT_APP_API_BASE_URL}/documents/file/${selectedBeneficiary.profileBeneficiaryId}/${document.filename}`
                  : `${process.env.REACT_APP_API_BASE_URL}/documents/file/${formData.id}/${document.filename}`
                : null;
              return (
                <tr key={doc.id}>
                  <td>
                    <span>{doc.label}</span>
                  </td>
                  <td style={{ whiteSpace: 'nowrap', width: '2%', textAlign: 'center' }}>
                    {fileUrl ? (
                      <Button variant="link" onClick={(e) => handleOpenDocument(fileUrl, e)}>
                        <FileEarmark size={25} color={'green'} />
                      </Button>
                    ) : (
                      <label>-</label>
                    )}
                  </td>
                  <td style={{ whiteSpace: 'nowrap', width: '2%', textAlign: 'center' }}>
                    <Button variant="outline-primary" onClick={() => handleEditClick(doc)}>
                      <PencilSquare size={20} />
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Row>
      {renderDocumentModal()}
      {isDocumentModalOpen && fileBlob && (
        <FileViewerModal
          isOpen={isDocumentModalOpen}
          file={fileBlob}
          handleCloseModal={() => setIsDocumentModalOpen(false)}
        />
      )}
    </Container>
  );

  const renderDocumentModal = () => (
    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Editar {selectedDocument?.label}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Seleccionar archivo</Form.Label>
          <Form.Control
            type="file"
            onChange={(e) => handleFileChange(e, selectedDocument.id, index)}
            accept=".pdf,.jpg,.png"
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={() => setShowModal(false)}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            const documentType = selectedDocument.id;
            setFiles([...files, documentType]);
            setShowModal(false);
          }}
        >
          Seleccionar
        </Button>
      </Modal.Footer>
    </Modal>
  );

  const handleCloseBeneficiaryModal = () => {
    setShowModalBeneficiary(false);
    setSelectedBeneficiary(null);
    if (setSelectedBeneficiaryIndex) {
      setSelectedBeneficiaryIndex(null);
    }
  };

  const addBeneficiary = () => {
    // Add new beneficiary
    const newBeneficiary = {
      firstName: '',
      lastName: '',
      birthDate: '',
      rfc: '',
      phone: '',
      address: '',
      email: '',
      state: '',
      city: '',
      zipCode: '',
      neighborhood: '',
      addressNumber: '',
      bankId: 1,
      clabe: '',
      documents: [],
      isNew: true,
      profileBeneficiaryId: 0,
    };
    const index = formData.beneficiaries ? formData.beneficiaries.length : 0;
    setSelectedBeneficiary({ ...newBeneficiary, index });
    if (setSelectedBeneficiaryIndex) {
      setSelectedBeneficiaryIndex(index);
    }
    setShowModalBeneficiary(true);
  };

  const renderBeneficiaries = () => {
    return (
      <Container>
        <Row className="mb-3 mt-5 form-title">
          <Col md={6} className="d-flex align-items-center">
            <People size={18} className="me-2" />
            <h4>Beneficiarios</h4>
          </Col>
          <Col md={6} className="text-end">
            <Button size="sm" onClick={addBeneficiary}>
              + Agregar
            </Button>
          </Col>
        </Row>
        <Row className="mb-3 mt-5">
          <Table responsive striped bordered hover>
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {formData.beneficiaries?.map((beneficiary: any, index: number) => {
                return (
                  <tr key={beneficiary.profileBeneficiaryId}>
                    <td>
                      <span>{`${beneficiary.firstName} ${beneficiary.lastName}`}</span>
                    </td>
                    <td style={{ whiteSpace: 'nowrap', width: '2%', textAlign: 'center' }}>
                      <Button
                        variant="outline-primary"
                        onClick={() => {
                          setSelectedBeneficiary({ ...beneficiary, index });
                          if (setSelectedBeneficiaryIndex) {
                            setSelectedBeneficiaryIndex(index);
                          }
                          setShowModalBeneficiary(true);
                        }}
                      >
                        <PencilSquare size={20} />
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Row>
        {renderBeneficiaryModal()}
      </Container>
    );
  };

  const renderBeneficiaryModal = () => {
    return (
      <Modal show={showModalBeneficiary} onHide={handleCloseBeneficiaryModal} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Editar Beneficiario</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {renderPersonalData()}
          {renderFiscalData()}
          {renderBankData()}
          {renderDocuments()}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={handleCloseBeneficiaryModal}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleBeneficiaryButton}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <Container>
      {renderPersonalData()}
      {renderFiscalData()}
      {renderBankData()}

      {isEdit ? renderDocuments() : renderUploadDocuments()}
      {isEdit && renderBeneficiaries()}
    </Container>
  );
};

export default CustomerFormFields;
